'use client';

import Script from 'next/script';
import { useDealershipConfiguration } from '~/context/dealership/StaticContext';

export default function AutoLeadStarScript() {
  const { autoLeadStarCode } = useDealershipConfiguration();

  return autoLeadStarCode ? (
    <Script
      src={`https://cdn.autoleadstar.com/track-${autoLeadStarCode}.js`}
      strategy="beforeInteractive"
    />
  ) : null;
}
